(function () {
  if (window.cartGiftAutomationLoaded) return;
  window.cartGiftAutomationLoaded = true;

  function getConfig() {
    return window.cartGiftConfig || null;
  }

  // Shopify /cart.js does not include a line number — inject it from array index.
  function withLineNumbers(items) {
    return items.map((item, index) => ({ ...item, line: index + 1 }));
  }

  function calculateEligibleTotal(items) {
    const config = getConfig();
    return items.reduce((sum, item) => {
      if (item.product_id === config.productId) return sum;
      return sum + item.final_line_price;
    }, 0);
  }

  // Prop-only — "is gift already in cart?" (price not checked: Shopify applies discount with delay)
  function findGiftItemByProp(items) {
    const config = getConfig();
    return items.find(
      (item) =>
        item.product_id === config.productId &&
        item.properties._CustomGifted === 'true'
    ) || null;
  }

  // Prop + price=0 — "is there a free gift to remove?"
  function findFreeGiftItem(items) {
    const config = getConfig();
    return items.find(
      (item) =>
        item.product_id === config.productId &&
        item.properties._CustomGifted === 'true' &&
        item.final_price === 0
    ) || null;
  }

  // Paid duplicates: our prop present but price > 0 (discount timing artifact)
  function findPaidGiftDuplicates(items) {
    const config = getConfig();
    return items.filter(
      (item) =>
        item.product_id === config.productId &&
        item.properties._CustomGifted === 'true' &&
        item.final_price > 0
    );
  }

  function addGift() {
    const config = getConfig();
    console.debug('[CartGift] adding gift variant', config.variantId);
    const body = JSON.stringify({
      items: [{ id: config.variantId, quantity: 1, properties: { _CustomGifted: 'true' } }],
    });
    return fetch(routes.cart_add_url, { ...fetchConfig(), body });
  }

  function removeGift(line) {
    console.debug('[CartGift] removing gift at line', line);
    const body = JSON.stringify({ line, quantity: 0 });
    return fetch(routes.cart_change_url, { ...fetchConfig(), body });
  }

  async function cleanupPaidDuplicates(items) {
    const duplicates = findPaidGiftDuplicates(items);
    if (!duplicates.length) return false;
    console.debug('[CartGift] removing paid duplicates at lines:', duplicates.map((i) => i.line));
    for (const item of [...duplicates].reverse()) {
      await removeGift(item.line);
    }
    return true;
  }

  // Core sync logic — returns true if the cart was mutated (gift added or removed).
  // Called by window.cartGiftSync (from cart.js updateQuantity) and on page load.
  async function syncGiftInternal(cartData) {
    const config = getConfig();
    if (!config || !config.enabled || !config.productId) return false;

    const items = withLineNumbers(cartData.items);

    const hadDuplicates = await cleanupPaidDuplicates(items);
    if (hadDuplicates) return true;

    const eligibleTotal = calculateEligibleTotal(items);
    const giftItemByProp = findGiftItemByProp(items);
    const freeGiftItem = findFreeGiftItem(items);

    console.debug('[CartGift] eligible:', eligibleTotal, 'threshold:', config.threshold, 'giftByProp:', !!giftItemByProp, 'freeGift:', !!freeGiftItem);

    if (eligibleTotal >= config.threshold && !giftItemByProp) {
      await addGift();
      return true;
    }

    if (eligibleTotal < config.threshold && freeGiftItem) {
      await removeGift(freeGiftItem.line);
      return true;
    }

    console.debug('[CartGift] no action needed');
    return false;
  }

  // Called by cart.js updateQuantity BEFORE section render.
  // If returns true, cart.js skips its own render and calls onCartUpdate() for a fresh fetch.
  window.cartGiftSync = syncGiftInternal;

  // Initial page load: cart HTML is already on the page (from Liquid, opacity:0).
  // Sync first, then reveal — user only ever sees the correct cart state.
  document.addEventListener('DOMContentLoaded', async () => {
    const config = getConfig();
    const cartEl = document.querySelector('cart-items[data-gift-sync]');
    if (!config || !config.enabled || !cartEl) return;

    try {
      const cartData = await fetch('/cart.js').then((r) => r.json());
      const mutated = await syncGiftInternal(cartData);
      if (mutated) {
        // Re-fetch section so Liquid re-evaluates is_free_gift detection
        const sectionId = cartEl.dataset.id;
        const text = await fetch(`${routes.cart_url}?section_id=${sectionId}`).then((r) => r.text());
        const html = new DOMParser().parseFromString(text, 'text/html');
        const source = html.querySelector('cart-items');
        if (source) cartEl.innerHTML = source.innerHTML;
      }
    } catch (err) {
      console.error('[CartGift] init failed', err);
    } finally {
      cartEl.style.opacity = '1';
    }
  });
})();
